import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null); // "retreats" or "offerings" or null
  const timerRef = useRef(null);

  // Refs for click outside detection
  const retreatsRef = useRef(null);
  const retreatsDropdownRef = useRef(null);
  const offeringsRef = useRef(null);
  const offeringsDropdownRef = useRef(null);
  const knowRef = useRef(null);
  const knowDropdownRef = useRef(null);


  // Generic mouse enter handler for dropdowns
  const handleMouseEnter = (dropdownName) => {
    clearTimeout(timerRef.current);
    setActiveDropdown(dropdownName);
  };

  // Generic mouse leave handler
  const handleMouseLeave = () => {
    timerRef.current = setTimeout(() => {
      setActiveDropdown(null);
    }, 300); // Adjust delay as needed
  };

  // Close dropdown when clicking outside of either dropdown or its trigger
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        (retreatsRef.current && !retreatsRef.current.contains(event.target) &&
         retreatsDropdownRef.current && !retreatsDropdownRef.current.contains(event.target)) &&
        (offeringsRef.current && !offeringsRef.current.contains(event.target) &&
         offeringsDropdownRef.current && !offeringsDropdownRef.current.contains(event.target))
         (knowRef.current && !knowRef.current.contains(event.target) &&
         knowDropdownRef.current && !knowDropdownRef.current.contains(event.target))

      ) {
        setActiveDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <nav className="bg-white shadow-md md:py-6 py-5 px-5 md:px-22 relative z-50">
      <div className="container mx-auto flex justify-between items-center">
        {/* Logo */}
        <Link to="/">
          <img src="/logo.png" alt="PARAM Logo" className="h-12" />
        </Link>

        {/* Desktop Menu */}
        <ul className="hidden md:flex space-x-8 text-lg py-2 font-medium text-secondary">
          <li>
            <Link to="/" className="text-secondary pb-1 border-b-2 border-transparent hover:border-secondary transition">
              Home
            </Link>
          </li>

          {/* Retreats Dropdown */}
          <li
            className="relative"
            ref={retreatsRef}
            onMouseEnter={() => handleMouseEnter("retreats")}
            onMouseLeave={handleMouseLeave}
          >
            <span className="cursor-pointer text-secondary border-b-2 border-transparent pb-1 hover:border-secondary transition">
              Retreats
            </span>
            {activeDropdown === "retreats" && (
              <ul
                ref={retreatsDropdownRef}
                className="absolute left-0 mt-2 w-64 bg-white shadow-lg rounded-lg p-4 z-50"
                onMouseEnter={() => handleMouseEnter("retreats")}
                onMouseLeave={handleMouseLeave}
              >
                <li>
                  <Link
                    to="/retreats/innergise"
                    className="block px-4 py-2 text-lg font-bold text-black hover:text-secondary"
                  >
                    Innergise
                  </Link>
                </li>
                <hr className="border-t border-gray-300 my-1" />
                <li>
                  <Link
                    to="/retreats/synnergise"
                    className="block px-4 py-2 text-lg font-bold text-black hover:text-secondary"
                  >
                    Synergise
                  </Link>
                </li>
                <hr className="border-t border-gray-300 my-1" />
                <li>
                  <Link
                    to="/retreats/innerQuiet"
                    className="block px-4 py-2 text-lg font-bold text-black hover:text-secondary"
                  >
                    InnerQuiet
                  </Link>
                </li>
              </ul>
            )}
          </li>

          {/* Offerings Dropdown */}
          <li
            className="relative"
            ref={offeringsRef}
            onMouseEnter={() => handleMouseEnter("offerings")}
            onMouseLeave={handleMouseLeave}
          >
            <span className="cursor-pointer text-secondary border-b-2 border-transparent pb-1 hover:border-secondary transition">
              Offerings
            </span>
            {activeDropdown === "offerings" && (
              <ul
                ref={offeringsDropdownRef}
                className="absolute left-0 mt-2 w-64 bg-white shadow-lg rounded-lg p-4 z-50"
                onMouseEnter={() => handleMouseEnter("offerings")}
                onMouseLeave={handleMouseLeave}
              >
                <li>
                  <Link
                    to="/corporate-wellness"
                    className="block px-4 py-2 text-lg font-bold text-black hover:text-secondary"
                  >
                    Corporate Wellness
                  </Link>
                </li>
                <hr className="border-t border-gray-300 my-1" />
                <li>
                  <Link
                    to="/online-programs"
                    className="block px-4 py-2 text-lg font-bold text-black hover:text-secondary"
                  >
                    Online Programs
                  </Link>
                </li>
              </ul>
            )}
          </li>
          <li
            className="relative"
            ref={knowRef}
            onMouseEnter={() => handleMouseEnter("knowyourself")}
            onMouseLeave={handleMouseLeave}
          >
            <span className="cursor-pointer text-secondary border-b-2 border-transparent pb-1 hover:border-secondary transition">
              Know Yourself            </span>
            {activeDropdown ==="knowyourself" && (
              <ul
                ref={knowDropdownRef}
                className="absolute left-0 mt-2 w-64 bg-white shadow-lg rounded-lg p-4 z-50"
                onMouseEnter={() => handleMouseEnter("knowyourself")}
                onMouseLeave={handleMouseLeave}
              >
                <li>
                  <Link
                    to="/wellness-quiz"
                    className="block px-4 py-2 text-lg font-bold text-black hover:text-secondary"
                  >
                    Wellness Quiz
                  </Link>
                </li>
                <hr className="border-t border-gray-300 my-1" />
                <li>
                  <Link
                    to="/wellness-blogs"
                    className="block px-4 py-2 text-lg font-bold text-black hover:text-secondary"
                  >
                   Wellness Blogs
                  </Link>
                </li>
              </ul>
            )}
          </li>

          <li>
            <Link
              to="/about"
              className="text-secondary pb-1 border-b-2 border-transparent hover:border-secondary transition"
            >
              About Us
            </Link>
          </li>
        </ul>

        {/* Mobile Menu Button */}
        <button onClick={() => setIsOpen(!isOpen)} className="md:hidden text-secondary text-2xl ml-auto">
          {isOpen ? <FaTimes /> : <FaBars />}
        </button>

        {/* Mobile Menu */}
        {isOpen && (
          <ul className="md:hidden bg-[#bfbfbf]/95 rounded px-6 py-2 w-full mt-4 absolute top-20 left-0 z-50">
            <li className="border-b border-white/30">
              <Link
                to="/"
                onClick={() => setIsOpen(false)}
                className="block py-2 text-lg text-secondary hover:#60212E"
              >
                Home
              </Link>
            </li>
            <li className="relative border-b border-white/3">
              <span className="block py-2 cursor-pointer text-lg text-secondary hover:#60212E">
                Retreats
              </span>
              <ul className="pl-4 bg-[#bfbfbf] max-h-48 overflow-y-auto">
                <li>
                  <Link
                    to="/retreats/synnergise"
                    onClick={() => setIsOpen(false)}
                    className="block py-2 hover:text-secondary text-white font-bold"
                  >
                    Synergise
                  </Link>
                </li>
                <li>
                  <Link
                    to="/retreats/innergise"
                    onClick={() => setIsOpen(false)}
                    className="block py-2 hover:text-secondary text-white font-bold"
                  >
                    Innergise
                  </Link>
                </li>
                <li>
                  <Link
                    to="/retreats/innerQuiet"
                    onClick={() => setIsOpen(false)}
                    className="block py-2 hover:text-secondary text-white font-bold"
                  >
                    InnerQuiet
                  </Link>
                </li>
              </ul>
            </li>
            <li className="relative border-b border-white/3">
              <span className="block py-2 cursor-pointer text-lg text-secondary hover:#60212E">
                Offerings
              </span>
              <ul className="pl-4 bg-[#bfbfbf] max-h-48 overflow-y-auto">
                <li>
                  <Link
                    to="/corporate-wellness"
                    onClick={() => setIsOpen(false)}
                    className="block py-2 hover:text-secondary text-white font-bold"
                  >
                    Corporate Wellness
                  </Link>
                </li>
                <li>
                  <Link
                    to="/online-programs"
                    onClick={() => setIsOpen(false)}
                    className="block py-2 hover:text-secondary text-white font-bold"
                  >
                    Online Programs
                  </Link>
                </li>
              </ul>
            </li>
            <li className="relative border-b border-white/3">
              <span className="block py-2 cursor-pointer text-lg text-secondary hover:#60212E">
                Know Yourself
              </span>
              <ul className="pl-4 bg-[#bfbfbf] max-h-48 overflow-y-auto">
                <li>
                  <Link
                    to="/wellness-quiz"
                    onClick={() => setIsOpen(false)}
                    className="block py-2 hover:text-secondary text-white font-bold"
                  >
                   Wellness Quiz
                  </Link>
                </li>
                <li>
                  <Link
                    to="/wellness-blogs"
                    onClick={() => setIsOpen(false)}
                    className="block py-2 hover:text-secondary text-white font-bold"
                  >
                   Wellness Blogs
                  </Link>
                </li>
              </ul>
            </li>
         
            <li className="border-b border-white/30">
              <Link
                to="/about"
                onClick={() => setIsOpen(false)}
                className="block py-2 text-lg text-secondary hover:#60212E"
              >
                About Us
              </Link>
            </li>
          </ul>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
